module.exports = __webpack_public_path__ + "img/EYE.5262bf37.svg";